const AdvisorSkeleton = () => (
  <div className="space-y-6 animate-pulse">
    <div className="h-20 rounded-xl bg-indigo-50/60 border border-indigo-100" />
    <div className="bg-white border border-neutral-200 rounded-xl overflow-hidden shadow-sm">
      <div className="px-5 py-4 border-b border-neutral-100 flex items-center justify-between">
        <div className="h-4 w-40 rounded bg-neutral-200" />
        <div className="h-3 w-28 rounded bg-neutral-200" />
      </div>
      <div className="divide-y divide-neutral-100">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="px-5 py-4 flex gap-4">
            <div className="h-3 w-24 rounded bg-neutral-100" />
            <div className="h-3 w-20 rounded bg-neutral-100" />
            <div className="h-3 w-32 rounded bg-neutral-100" />
            <div className="h-3 flex-1 rounded bg-neutral-100" />
          </div>
        ))}
      </div>
    </div>
  </div>
)

export default AdvisorSkeleton
